import { render } from "./ViewSlotsDetails.vue?vue&type=template&id=00269b77"
import script from "./ViewSlotsDetails.vue?vue&type=script&lang=js"
export * from "./ViewSlotsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__